import { render } from "./promotions.vue?vue&type=template&id=6e2257ad&scoped=true"
import script from "./promotions.vue?vue&type=script&lang=js"
export * from "./promotions.vue?vue&type=script&lang=js"

import "./promotions.vue?vue&type=style&index=0&id=6e2257ad&lang=scss"
import "./promotions.vue?vue&type=style&index=1&id=6e2257ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2257ad"]])

export default __exports__